import { VolumeUp as NoiseIcon } from '@mui/icons-material'
import { Tooltip } from '@mui/material'

import { SmokeIcon } from '@common/icons'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {Object} props.row
 * @param {boolean} [props.mobileView]
 */
export default function EventListTypeCell({ row, mobileView }) {
  switch (row.eventClass) {
    case 'NOISE':
      return (
        <Tooltip title="Noise">
          <NoiseIcon color="action" sx={{ fontSize: mobileView ? 18 : 24 }} />
        </Tooltip>
      )
    case 'SMOKE':
      return (
        <Tooltip title="Smoke">
          <SmokeIcon
            color="action"
            style={{ transform: 'rotate(-90deg)', fontSize: mobileView ? 18 : 24 }}
          />
        </Tooltip>
      )
    default:
      return null
  }
}
